import { DocumentReference } from "firebase/firestore";
import { Button, Card, Col, Input, message, Row } from "antd";
import { LoadingOverlay } from "../../../../../../components/LoadingOverlay";
import { VFC } from "react";
import { Game } from "../../../../utils/Game";
import { usePrepareForNamesMutation } from "../../../../utils/usePrepareForNamesMutation";
import { CopyOutlined } from "@ant-design/icons";
import { QuestionButton } from "../../../QuestionButton";

export const GameMasterStatusWaitForMembers: VFC<{
  gameRef: DocumentReference;
  game: Game;
  small: boolean;
}> = ({ gameRef, game, small }) => {
  const startMutation = usePrepareForNamesMutation();

  return (
    <Card
      title={small ? undefined : "Spielstart"}
      extra={small ? undefined : <QuestionButton />}
    >
      {startMutation.isLoading && <LoadingOverlay />}
      <Row gutter={[8, 8]}>
        <Col span={24}>
          Wenn alle Mitspieler da sind, kannst du das Spiel starten.
        </Col>
        <Col span={24}>
          <Input
            readOnly
            value={window.location.href}
            addonAfter={
              <CopyOutlined
                onClick={async () => {
                  await navigator.clipboard.writeText(window.location.href);
                  message.success("URL kopiert.");
                }}
              />
            }
          />
        </Col>
        <Col span={24}>
          <Button
            type={"primary"}
            onClick={() => {
              startMutation.mutate();
            }}
            block
          >
            Spiel starten
          </Button>
        </Col>
      </Row>
    </Card>
  );
};
